import service from "../../../lib";
import { AxiosResponse } from "axios";

type GetSubscriptionParams = {
  phone: string;
};

export type SubscribeResponse<T = any> = AxiosResponse<T>;

const subscribeApi = {
  
  getToken: (token: string): Promise<SubscribeResponse> => {
    return service.post<SubscribeResponse>(`/signin`, {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  getSubscription: (): Promise<SubscribeResponse> => {
    return service.get<SubscribeResponse>(`/subscribe`);
  },

};

export default subscribeApi;

